"use strict";
/**
 * @description
 * ISO 4217 currency codes
 * @see https://en.wikipedia.org/wiki/ISO_4217
 *
 * List extracted from Intl.supportedValuesOf('currency')
 * if you want to update this list, run the command:
 * Intl.supportedValuesOf('currency')
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
var Currency;
(function (Currency) {
    /**
     * United Arab Emirates Dirham
     */
    Currency["AED"] = "AED";
    /**
     * Afghan Afghani
     */
    Currency["AFN"] = "AFN";
    /**
     * Albanian Lek
     */
    Currency["ALL"] = "ALL";
    /**
     * Armenian Dram
     */
    Currency["AMD"] = "AMD";
    /**
     * Netherlands Antillean Guilder
     */
    Currency["ANG"] = "ANG";
    /**
     * Angolan Kwanza
     */
    Currency["AOA"] = "AOA";
    /**
     * Argentine Peso
     */
    Currency["ARS"] = "ARS";
    /**
     * Australian Dollar
     */
    Currency["AUD"] = "AUD";
    /**
     * Aruban Florin
     */
    Currency["AWG"] = "AWG";
    /**
     * Azerbaijani Manat
     */
    Currency["AZN"] = "AZN";
    /**
     * Bosnia-Herzegovina Convertible Mark
     */
    Currency["BAM"] = "BAM";
    /**
     * Barbadian Dollar
     */
    Currency["BBD"] = "BBD";
    /**
     * Bangladeshi Taka
     */
    Currency["BDT"] = "BDT";
    /**
     * Bulgarian Lev
     */
    Currency["BGN"] = "BGN";
    /**
     * Bahraini Dinar
     */
    Currency["BHD"] = "BHD";
    /**
     * Burundian Franc
     */
    Currency["BIF"] = "BIF";
    /**
     * Bermudian Dollar
     */
    Currency["BMD"] = "BMD";
    /**
     * Brunei Dollar
     */
    Currency["BND"] = "BND";
    /**
     * Bolivian Boliviano
     */
    Currency["BOB"] = "BOB";
    /**
     * Brazilian Real
     */
    Currency["BRL"] = "BRL";
    /**
     * Bahamian Dollar
     */
    Currency["BSD"] = "BSD";
    /**
     * Bhutanese Ngultrum
     */
    Currency["BTN"] = "BTN";
    /**
     * Botswana Pula
     */
    Currency["BWP"] = "BWP";
    /**
     * Belarusian Ruble
     */
    Currency["BYN"] = "BYN";
    /**
     * Belize Dollar
     */
    Currency["BZD"] = "BZD";
    /**
     * Canadian Dollar
     */
    Currency["CAD"] = "CAD";
    /**
     * Congolese Franc
     */
    Currency["CDF"] = "CDF";
    /**
     * Swiss Franc
     */
    Currency["CHF"] = "CHF";
    /**
     * Chilean Peso
     */
    Currency["CLP"] = "CLP";
    /**
     * Chinese Yuan
     */
    Currency["CNY"] = "CNY";
    /**
     * Colombian Peso
     */
    Currency["COP"] = "COP";
    /**
     * Costa Rican Colón
     */
    Currency["CRC"] = "CRC";
    /**
     * Cuban Convertible Peso
     */
    Currency["CUC"] = "CUC";
    /**
     * Cuban Peso
     */
    Currency["CUP"] = "CUP";
    /**
     * Cape Verdean Escudo
     */
    Currency["CVE"] = "CVE";
    /**
     * Czech Republic Koruna
     */
    Currency["CZK"] = "CZK";
    /**
     * Djiboutian Franc
     */
    Currency["DJF"] = "DJF";
    /**
     * Danish Krone
     */
    Currency["DKK"] = "DKK";
    /**
     * Dominican Peso
     */
    Currency["DOP"] = "DOP";
    /**
     * Algerian Dinar
     */
    Currency["DZD"] = "DZD";
    /**
     * Egyptian Pound
     */
    Currency["EGP"] = "EGP";
    /**
     * Eritrean Nakfa
     */
    Currency["ERN"] = "ERN";
    /**
     * Ethiopian Birr
     */
    Currency["ETB"] = "ETB";
    /**
     * Euro
     */
    Currency["EUR"] = "EUR";
    /**
     * Fijian Dollar
     */
    Currency["FJD"] = "FJD";
    /**
     * Falkland Islands Pound
     */
    Currency["FKP"] = "FKP";
    /**
     * British Pound Sterling
     */
    Currency["GBP"] = "GBP";
    /**
     * Georgian Lari
     */
    Currency["GEL"] = "GEL";
    /**
     * Ghanaian Cedi
     */
    Currency["GHS"] = "GHS";
    /**
     * Gibraltar Pound
     */
    Currency["GIP"] = "GIP";
    /**
     * Gambian Dalasi
     */
    Currency["GMD"] = "GMD";
    /**
     * Guinean Franc
     */
    Currency["GNF"] = "GNF";
    /**
     * Guatemalan Quetzal
     */
    Currency["GTQ"] = "GTQ";
    /**
     * Guyanaese Dollar
     */
    Currency["GYD"] = "GYD";
    /**
     * Hong Kong Dollar
     */
    Currency["HKD"] = "HKD";
    /**
     * Honduran Lempira
     */
    Currency["HNL"] = "HNL";
    /**
     * Croatian Kuna
     */
    Currency["HRK"] = "HRK";
    /**
     * Haitian Gourde
     */
    Currency["HTG"] = "HTG";
    /**
     * Hungarian Forint
     */
    Currency["HUF"] = "HUF";
    /**
     * Indonesian Rupiah
     */
    Currency["IDR"] = "IDR";
    /**
     * Israeli New Shekel
     */
    Currency["ILS"] = "ILS";
    /**
     * Indian Rupee
     */
    Currency["INR"] = "INR";
    /**
     * Iraqi Dinar
     */
    Currency["IQD"] = "IQD";
    /**
     * Iranian Rial
     */
    Currency["IRR"] = "IRR";
    /**
     * Icelandic Króna
     */
    Currency["ISK"] = "ISK";
    /**
     * Jamaican Dollar
     */
    Currency["JMD"] = "JMD";
    /**
     * Jordanian Dinar
     */
    Currency["JOD"] = "JOD";
    /**
     * Japanese Yen
     */
    Currency["JPY"] = "JPY";
    /**
     * Kenyan Shilling
     */
    Currency["KES"] = "KES";
    /**
     * Kyrgyzstani Som
     */
    Currency["KGS"] = "KGS";
    /**
     * Cambodian Riel
     */
    Currency["KHR"] = "KHR";
    /**
     * Comorian Franc
     */
    Currency["KMF"] = "KMF";
    /**
     * North Korean Won
     */
    Currency["KPW"] = "KPW";
    /**
     * South Korean Won
     */
    Currency["KRW"] = "KRW";
    /**
     * Kuwaiti Dinar
     */
    Currency["KWD"] = "KWD";
    /**
     * Cayman Islands Dollar
     */
    Currency["KYD"] = "KYD";
    /**
     * Kazakhstani Tenge
     */
    Currency["KZT"] = "KZT";
    /**
     * Laotian Kip
     */
    Currency["LAK"] = "LAK";
    /**
     * Lebanese Pound
     */
    Currency["LBP"] = "LBP";
    /**
     * Sri Lankan Rupee
     */
    Currency["LKR"] = "LKR";
    /**
     * Liberian Dollar
     */
    Currency["LRD"] = "LRD";
    /**
     * Lesotho Loti
     */
    Currency["LSL"] = "LSL";
    /**
     * Libyan Dinar
     */
    Currency["LYD"] = "LYD";
    /**
     * Moroccan Dirham
     */
    Currency["MAD"] = "MAD";
    /**
     * Moldovan Leu
     */
    Currency["MDL"] = "MDL";
    /**
     * Malagasy Ariary
     */
    Currency["MGA"] = "MGA";
    /**
     * Macedonian Denar
     */
    Currency["MKD"] = "MKD";
    /**
     * Myanmar Kyat
     */
    Currency["MMK"] = "MMK";
    /**
     * Mongolian Tugrik
     */
    Currency["MNT"] = "MNT";
    /**
     * Macanese Pataca
     */
    Currency["MOP"] = "MOP";
    /**
     * Mauritanian Ouguiya
     */
    Currency["MRU"] = "MRU";
    /**
     * Mauritian Rupee
     */
    Currency["MUR"] = "MUR";
    /**
     * Maldivian Rufiyaa
     */
    Currency["MVR"] = "MVR";
    /**
     * Malawian Kwacha
     */
    Currency["MWK"] = "MWK";
    /**
     * Mexican Peso
     */
    Currency["MXN"] = "MXN";
    /**
     * Malaysian Ringgit
     */
    Currency["MYR"] = "MYR";
    /**
     * Mozambican Metical
     */
    Currency["MZN"] = "MZN";
    /**
     * Namibian Dollar
     */
    Currency["NAD"] = "NAD";
    /**
     * Nigerian Naira
     */
    Currency["NGN"] = "NGN";
    /**
     * Nicaraguan Córdoba
     */
    Currency["NIO"] = "NIO";
    /**
     * Norwegian Krone
     */
    Currency["NOK"] = "NOK";
    /**
     * Nepalese Rupee
     */
    Currency["NPR"] = "NPR";
    /**
     * New Zealand Dollar
     */
    Currency["NZD"] = "NZD";
    /**
     * Omani Rial
     */
    Currency["OMR"] = "OMR";
    /**
     * Panamanian Balboa
     */
    Currency["PAB"] = "PAB";
    /**
     * Peruvian Nuevo Sol
     */
    Currency["PEN"] = "PEN";
    /**
     * Papua New Guinean Kina
     */
    Currency["PGK"] = "PGK";
    /**
     * Philippine Peso
     */
    Currency["PHP"] = "PHP";
    /**
     * Pakistani Rupee
     */
    Currency["PKR"] = "PKR";
    /**
     * Polish Zloty
     */
    Currency["PLN"] = "PLN";
    /**
     * Paraguayan Guarani
     */
    Currency["PYG"] = "PYG";
    /**
     * Qatari Rial
     */
    Currency["QAR"] = "QAR";
    /**
     * Romanian Leu
     */
    Currency["RON"] = "RON";
    /**
     * Serbian Dinar
     */
    Currency["RSD"] = "RSD";
    /**
     * Russian Ruble
     */
    Currency["RUB"] = "RUB";
    /**
     * Rwandan Franc
     */
    Currency["RWF"] = "RWF";
    /**
     * Saudi Riyal
     */
    Currency["SAR"] = "SAR";
    /**
     * Solomon Islands Dollar
     */
    Currency["SBD"] = "SBD";
    /**
     * Seychellois Rupee
     */
    Currency["SCR"] = "SCR";
    /**
     * Sudanese Pound
     */
    Currency["SDG"] = "SDG";
    /**
     * Swedish Krona
     */
    Currency["SEK"] = "SEK";
    /**
     * Singapore Dollar
     */
    Currency["SGD"] = "SGD";
    /**
     * Saint Helena Pound
     */
    Currency["SHP"] = "SHP";
    /**
     * Sierra Leonean Leone
     */
    Currency["SLL"] = "SLL";
    /**
     * Somali Shilling
     */
    Currency["SOS"] = "SOS";
    /**
     * Surinamese Dollar
     */
    Currency["SRD"] = "SRD";
    /**
     * South Sudanese Pound
     */
    Currency["SSP"] = "SSP";
    /**
     * São Tomé and Príncipe Dobra
     */
    Currency["STN"] = "STN";
    /**
     * Salvadoran Colón
     */
    Currency["SVC"] = "SVC";
    /**
     * Syrian Pound
     */
    Currency["SYP"] = "SYP";
    /**
     * Swazi Lilangeni
     */
    Currency["SZL"] = "SZL";
    /**
     * Thai Baht
     */
    Currency["THB"] = "THB";
    /**
     * Tajikistani Somoni
     */
    Currency["TJS"] = "TJS";
    /**
     * Turkmenistani Manat
     */
    Currency["TMT"] = "TMT";
    /**
     * Tunisian Dinar
     */
    Currency["TND"] = "TND";
    /**
     * Tongan Pa'anga
     */
    Currency["TOP"] = "TOP";
    /**
     * Turkish Lira
     */
    Currency["TRY"] = "TRY";
    /**
     * Trinidad and Tobago Dollar
     */
    Currency["TTD"] = "TTD";
    /**
     * New Taiwan Dollar
     */
    Currency["TWD"] = "TWD";
    /**
     * Tanzanian Shilling
     */
    Currency["TZS"] = "TZS";
    /**
     * Ukrainian Hryvnia
     */
    Currency["UAH"] = "UAH";
    /**
     * Ugandan Shilling
     */
    Currency["UGX"] = "UGX";
    /**
     * United States Dollar
     */
    Currency["USD"] = "USD";
    /**
     * Uruguayan Peso
     */
    Currency["UYU"] = "UYU";
    /**
     * Uzbekistan Som
     */
    Currency["UZS"] = "UZS";
    /**
     * Venezuelan Bolívar
     */
    Currency["VES"] = "VES";
    /**
     * Vietnamese Dong
     */
    Currency["VND"] = "VND";
    /**
     * Vanuatu Vatu
     */
    Currency["VUV"] = "VUV";
    /**
     * Samoan Tala
     */
    Currency["WST"] = "WST";
    /**
     * Central African CFA Franc
     */
    Currency["XAF"] = "XAF";
    /**
     * East Caribbean Dollar
     */
    Currency["XCD"] = "XCD";
    /**
     * Special Drawing Rights
     */
    Currency["XDR"] = "XDR";
    /**
     * West African CFA Franc
     */
    Currency["XOF"] = "XOF";
    /**
     * CFP Franc
     */
    Currency["XPF"] = "XPF";
    /**
     * Sucre
     */
    Currency["XSU"] = "XSU";
    /**
     * Yemeni Rial
     */
    Currency["YER"] = "YER";
    /**
     * South African Rand
     */
    Currency["ZAR"] = "ZAR";
    /**
     * Zambian Kwacha
     */
    Currency["ZMW"] = "ZMW";
    /**
     * Zimbabwean Dollar
     */
    Currency["ZWL"] = "ZWL";
})(Currency || (exports.Currency = Currency = {}));
//# sourceMappingURL=currency.js.map